// src/pages/Unauthorized.js
import React from "react";
import { Link } from "react-router-dom";
import "./styles/Unauthorized.css";

const Unauthorized = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "3rem" }}>
      <h2>Unauthorized</h2>
      <p>You don’t have permission to view this page.</p>
      <p>
        <Link to="/">Go back Home</Link> or <Link to="/login">Login</Link>
      </p>
    </div>
  );
};

export default Unauthorized;
